import { Text } from '@brokerbay/elements-web';
import { Select, SelectOption } from 'components';
import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { correctShowingTypeLabel } from 'utils';
import { agentAppointmentTypes } from '../../constants';
import CoopSelectContext from '../CoopSelectContext';

const ShowingTypeSelector: React.FC = () => {
  const { apptType, setApptType } = useContext(CoopSelectContext);

  useEffect(() => {
    setApptType(agentAppointmentTypes[0]);
  }, [setApptType]);

  return (
    <div>
      <Text>Showing Type</Text>
      <StyledSelect
        value={apptType}
        id="showing-type"
        data-cy="showing-type"
        onChange={type => setApptType(type)}
        showSearch
      >
        {agentAppointmentTypes.map(type => (
          <SelectOption
            key={type}
            value={type}
            data-cy={`showing-type-${type}`}
          >
            {correctShowingTypeLabel(type)}
          </SelectOption>
        ))}
      </StyledSelect>
    </div>
  );
};

const StyledSelect = styled(Select)`
  margin-bottom: 8px;
  .ant-select > .ant-select-selector {
    background-color: #fff;
    border: 1px solid #e4e5e7;
  }
`;

export default ShowingTypeSelector;
